<template>
  <div v-if="!isCheckRoute && isNewTrial" class="trial-tooltip-plan" :class="{ 'trial-warning': isWarning && isCheckRoute, 'sub-page': !isCheckRoute }">
    <template v-if="!isCheckRoute && isNewTrial">
      <img class="info-icon-small" src="../assets/info_icon.svg" />
      <div class="plan-info-center" v-html="trialContent"></div>
      <div class="plan-right">
        <router-link
          replace
          :to="{
            name: 'Pricing'
          }"
        >
          {{ $t("generals.upgrade") }}</router-link
        >
        <!-- <div @click="onClose" class="close-icon">
          <img src="../assets/close_icon.svg" />
        </div> -->
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { PLAN_NO } from "@/contants/plan";
const ROUTES_NOT_DISPLAY = ["dashboard"];
export default {
  name: "TrialTooltipPlan",
  props: {
    from: {
      type: String,
      default: "dashboard"
    }
  },

  data() {
    return {
      ROUTES_NOT_DISPLAY
    };
  },

  computed: {
    ...mapState({
      shopInfo: state => state.account.shopInfo,
      publishedPagesCountStore: state => state.page.publishedPageCount || 0
    }),
    remainingDays() {
      return this.shopInfo?.remainingDays !== undefined && this.shopInfo?.remainingDays !== null ? this.shopInfo?.remainingDays : 30;
    },
    isCheckRoute() {
      return ROUTES_NOT_DISPLAY.includes(this.from);
    },
    isWarning() {
      return this.remainingDays <= 7;
    },
    isTrial() {
      return (this.shopInfo?.plan === PLAN_NO.TRIAL && this.from === "dashboard") || this.shopInfo?.plan === "trial2022" || (this.isOldTrial && this.isExpired);
    },

    isNewTrial() {
      return this.shopInfo?.plan === PLAN_NO.TRIAL2022;
    },

    isOldTrial() {
      return this.shopInfo?.plan === PLAN_NO.TRIAL;
    },

    isExpired() {
      return this.remainingDays <= 0;
    },
    trialLimitNumberPagePublish() {
      const { planLimitation } = this.shopInfo || {};
      if (planLimitation) {
        return planLimitation.trial2022?.pagePublish?.nbOfPublishedPage || 0;
      }
      return 0;
    },

    publishedPagesCount() {
      return (this.shopInfo?.publishedPagesCount || 0) + this.publishedPagesCountStore;
    },
    trialContent() {
      return !this.isExpired ? this.$t("pricing.trial.subpagePublished", { value: this.trialLimitNumberPagePublish, count: `${this.publishedPagesCount}/${this.trialLimitNumberPagePublish}` }) : this.$t("pricing.trial.subpageExpired");
    }
  },

  methods: {
    getPlanInfo() {
      const endTrialDate = moment(this.shopInfo?.endTrialDate).format("MMM DD, YYYY");
      if (this.remainingDays > 7) {
        return {
          title: this.$t("pricing.trial.titleStart", { value: this.remainingDays }),
          desc: this.isNewTrial ? this.$t("pricing.trial.descStart", { value: endTrialDate }) : this.$t("pricing.oldTrial.descStart", { value: endTrialDate })
        };
      } else if (this.remainingDays > 0) {
        return {
          title: this.$t("pricing.trial.titleWarning", { value: this.remainingDays }),
          desc: this.$t("pricing.trial.descWarning", { value: endTrialDate })
        };
      }

      return {
        title: this.$t("pricing.trial.titleExpired"),
        desc: this.$t("pricing.trial.descExpired")
      };
    },

    onClose() {
      this.isShow = false;
    }
  }
};
</script>

<style scoped lang="scss">
.trial-tooltip-plan {
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  background-color: #d8e1ff;
  border-radius: 3px;
  &.trial-warning {
    background-color: #fed571;
  }
  &.sub-page {
    margin-bottom: -4px;
  }
  .info-icon {
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    margin-right: 16px;
    img {
      width: 21px;
      height: 21px;
      &.warning {
        height: 19.204177856445312px;
        width: 21.86865997314453px;
      }
    }
  }
  .info-trial-container {
    font-family: "Inter";
    font-style: normal;
    color: #212121;
    flex: 1;
    .info-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 4px;
    }

    .info-desc {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      max-width: 573px;
      margin-bottom: 8px;
    }
    a {
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #3c67ff;
      cursor: pointer;
    }
  }
  .plan-right {
    a {
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #3c67ff;
      cursor: pointer;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    display: flex;
    align-items: center;
  }
  .plan-info-center {
    display: flex;
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #212121;
  }
  .info-icon-small {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  .close-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 11px;
      height: 11px;
    }
  }
}
</style>
